import React from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";
import { neturalBlack, netural400, netural50 } from "../../../constants/color";
import { formatCurrency, formatDate, formatId } from "../../../utils/marketplaceHelpers";
import TransferStatusBadge from "./TransferStatusBadge";
import TransferOrderTypeChip from "./TransferOrderTypeChip";

const TransferTable = ({ transfers, loading }) => {
  const navigate = useNavigate();

  const handleRowClick = (transferId) => {
    navigate(`/admin/marketplace/transfers/${transferId}`);
  };

  if (loading) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          color: netural400,
          fontSize: "16px",
        }}
      >
        Loading transfers...
      </div>
    );
  }

  if (!transfers || transfers.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          color: netural400,
          fontSize: "16px",
        }}
      >
        No transfers found
      </div>
    );
  }

  return (
    <div
      style={{
        border: "1px solid #DADADA",
        borderRadius: "12px",
        overflow: "hidden",
        backgroundColor: "#ffffff",
      }}
    >
      <Table hover responsive style={{ marginBottom: 0 }}>
        <thead>
          <tr style={{ backgroundColor: netural50 }}>
            <th
              style={{
                padding: "16px 12px",
                fontSize: "14px",
                fontWeight: "600",
                color: netural400,
                borderBottom: "2px solid #DADADA",
              }}
            >
              ID
            </th>
            <th
              style={{
                padding: "16px 12px",
                fontSize: "14px",
                fontWeight: "600",
                color: netural400,
                borderBottom: "2px solid #DADADA",
              }}
            >
              Business
            </th>
            <th
              style={{
                padding: "16px 12px",
                fontSize: "14px",
                fontWeight: "600",
                color: netural400,
                borderBottom: "2px solid #DADADA",
              }}
            >
              Type
            </th>
            <th
              style={{
                padding: "16px 12px",
                fontSize: "14px",
                fontWeight: "600",
                color: netural400,
                borderBottom: "2px solid #DADADA",
              }}
            >
              Gross
            </th>
            <th
              style={{
                padding: "16px 12px",
                fontSize: "14px",
                fontWeight: "600",
                color: netural400,
                borderBottom: "2px solid #DADADA",
              }}
            >
              Net Paid
            </th>
            <th
              style={{
                padding: "16px 12px",
                fontSize: "14px",
                fontWeight: "600",
                color: netural400,
                borderBottom: "2px solid #DADADA",
              }}
            >
              Status
            </th>
            <th
              style={{
                padding: "16px 12px",
                fontSize: "14px",
                fontWeight: "600",
                color: netural400,
                borderBottom: "2px solid #DADADA",
              }}
            >
              Release
            </th>
          </tr>
        </thead>
        <tbody>
          {transfers.map((transfer) => (
            <tr
              key={transfer._id}
              onClick={() => handleRowClick(transfer._id)}
              style={{
                cursor: "pointer",
                transition: "background-color 0.15s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = netural50;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#ffffff";
              }}
            >
              <td
                style={{
                  padding: "12px",
                  fontSize: "14px",
                  color: netural400,
                  borderBottom: "1px solid #DADADA",
                }}
              >
                {formatId(transfer._id)}
              </td>
              <td
                style={{
                  padding: "12px",
                  fontSize: "14px",
                  color: neturalBlack,
                  borderBottom: "1px solid #DADADA",
                }}
              >
                {transfer.businessName || "—"}
              </td>
              <td
                style={{
                  padding: "12px",
                  fontSize: "14px",
                  borderBottom: "1px solid #DADADA",
                }}
              >
                <TransferOrderTypeChip orderType={transfer.orderType} />
              </td>
              <td
                style={{
                  padding: "12px",
                  fontSize: "14px",
                  color: neturalBlack,
                  borderBottom: "1px solid #DADADA",
                }}
              >
                {formatCurrency(transfer.grossAmount)}
              </td>
              <td
                style={{
                  padding: "12px",
                  fontSize: "14px",
                  color: neturalBlack,
                  fontWeight: "500",
                  borderBottom: "1px solid #DADADA",
                }}
              >
                {formatCurrency(transfer.sellerAmount)}
              </td>
              <td
                style={{
                  padding: "12px",
                  fontSize: "14px",
                  borderBottom: "1px solid #DADADA",
                }}
              >
                <TransferStatusBadge
                  status={transfer.status}
                  lastError={transfer.lastError}
                />
              </td>
              <td
                style={{
                  padding: "12px",
                  fontSize: "14px",
                  color: netural400,
                  borderBottom: "1px solid #DADADA",
                }}
              >
                {formatDate(transfer.releaseDate)}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default TransferTable;
